import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { EmbeddedHost } from '../shared/embedded-host.js';
import './sdb-composition-reset-all-button.js';
import './sdb-composition-reset-button-admin.js';
import './sdb-composition-reset-button.js';

@customElement('sdb-embedded-composition-reset-button')
class SdbEmbeddedCompositionResetButton extends EmbeddedHost(LitElement) {

    @property({ type: String })
    accessor compositionName;

    @property({ type: String })
    accessor label;

    @property({ type: String })
    accessor idString;

    @property({ type: Object })
    accessor idStrings;

    @property({ type: Boolean })
    accessor disabled = false;

    render() {
        if (!this.ready) {
            return nothing;
        }

        return html`
            ${this.idString ? html`
                <sdb-composition-reset-button-admin
                    .label=${this.label}
                    .compositionId=${this.compositionId}
                    .compositionName=${this.compositionName}
                    .idString=${this.idString}
                    ?disabled=${this.disabled}>
                </sdb-composition-reset-button-admin>
            `: this.idStrings ? html`
                <sdb-composition-reset-all-button
                    .label=${this.label}
                    .compositionId=${this.compositionId}
                    .compositionName=${this.compositionName}
                    .idStrings=${this.idStrings}
                    ?disabled=${this.disabled}>
                </sdb-composition-reset-all-button>
            ` : html`
                <sdb-composition-reset-button
                    .label=${this.label}
                    .compositionId=${this.compositionId}
                    .compositionName=${this.compositionName}
                    ?disabled=${this.disabled}>
                </sdb-composition-reset-button>
            `}
        `;
    }
}
